import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadSettingsTab from './download-settings-tab.jsx';
import RestoreSettingsTab from './restore-settings-tab.jsx';

function SystemSaveRestorePageView() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('download');

  const TABS = [
    { key: 'download', label: t('saveRestore.tabDownload') },
    { key: 'restore', label: t('saveRestore.tabRestore') },
  ];

  return (
    <div>
      <div className="page-header mb-4">
        <h2 className="page-title">{t('saveRestore.title')}</h2>
        <p className="text-muted">{t('saveRestore.subtitle')}</p>
      </div>

      <ul className="nav nav-tabs mb-4">
        {TABS.map((tab) => (
          <li className="nav-item" key={tab.key}>
            <button
              className={`nav-link${activeTab === tab.key ? ' active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {activeTab === 'download' && <DownloadSettingsTab />}
      {activeTab === 'restore' && <RestoreSettingsTab />}
    </div>
  );
}

export default SystemSaveRestorePageView;
